import React, { useEffect, useState } from "react";
import axios from "axios";
import { TextField, IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

export default function AdminForm() {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    axios
      .get("/api/updateadmin.php?action=get", {
        withCredentials: true,
      })
      .then((res) => {
        if (res.data) {
          setFormData({
            email: res.data.email || "",
            password: res.data.password || "",
          });
        }
      })
      .catch((err) => {
        setMessage("Failed to load admin data.");
      });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const form = new FormData();
      form.append("email", formData.email);
      form.append("password", formData.password);

      const res = await axios.post(
        "/api/updateadmin.php?action=update",
        form,
        { withCredentials: true }
      );

      setMessage(res.data.message || "Updated successfully!");
    } catch (err) {
      setMessage("Error updating details.");
    }
  };

  return (
    <div className="max-w-md ml-5 p-4  rounded mt-5 bg-white ">
      <h2 className="text-xl font-semibold mb-4 text-gray-700">Update Admin Details</h2>
      <form onSubmit={handleSubmit} className="space-y-4 text-gray-700">
        <div>
          <label className="block font-medium mb-3 text-sm">Email</label>
          <input
            type="email"
            value={formData.email}
            required
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            className="block w-full p-2 py-1 rounded bg-gray-200"
          />
        </div>
        <div>
          <label className="block font-medium mb-3 text-sm">Password</label>
          <TextField
  variant="outlined"
  fullWidth
  required
  type={showPassword ? 'text' : 'password'}
  value={formData.password}
  onChange={(e) => setFormData({ ...formData, password: e.target.value })}
  size="small"
  sx={{
    mb: 1,
    '& .MuiOutlinedInput-root': {
      background: '#e5e7eb',
      height: '36px',
      paddingRight: '8px',
      '& fieldset': {
        border: 'none', // removes the default outline
      },
      '&:hover fieldset': {
        border: 'none', // removes hover border
      },
      '&.Mui-focused fieldset': {
        border: 'none', // removes focus border
      },
    },
    '& input': {
      padding: '6px 8px',
    },
  }}
  InputProps={{
    endAdornment: (
      <InputAdornment position="end">
        <IconButton
          aria-label="toggle password visibility"
          onClick={() => setShowPassword((prev) => !prev)}
          edge="end"
          size="small"
        >
          {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
        </IconButton>
      </InputAdornment>
    ),
  }}
/>


        </div>
        <button
          type="submit"
          className="bg-gray-600 text-white px-4 py-1 rounded hover:bg-gray-700"
        >
          Update
        </button>
      </form>
      {message && <p className="mt-4 text-center text-sm">{message}</p>}
    </div>
  );
}
